var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 25H26.6666V28.3333H30M30 18.3333H26.6666V21.6667H30M33.3333 31.6667H20V28.3333H23.3333V25H20V21.6667H23.3333V18.3333H20V15H33.3333M16.6666 11.6667H13.3333V8.33333H16.6666M16.6666 18.3333H13.3333V15H16.6666M16.6666 25H13.3333V21.6667H16.6666M16.6666 31.6667H13.3333V28.3333H16.6666M9.99998 11.6667H6.66665V8.33333H9.99998M9.99998 18.3333H6.66665V15H9.99998M9.99998 25H6.66665V21.6667H9.99998M9.99998 31.6667H6.66665V28.3333H9.99998M20 11.6667V5H3.33331V35H36.6666V11.6667H20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyicon);
export default __webpack_public_path__ + "static/media/company.icon.29be8e07f7c72cda4f40b945cb86649b.svg";
export { ForwardRef as ReactComponent };